import axios from 'axios';

class ScanService {
  // Perform a website scan
  async scanWebsite(url, sitemapUrl = null) {
    try {
      const response = await axios.post('/api/analysis/scan', {
        url,
        sitemapUrl
      });
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // Get scan history for authenticated user
  async getScanHistory(page = 1, limit = 10) {
    try {
      const response = await axios.get('/api/analysis/history', {
        params: { page, limit }
      });
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // Get specific scan result by ID
  async getScanResult(id) {
    try {
      const response = await axios.get(`/api/analysis/${id}`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // Compare two domains (Plus tier only)
  async compareDomains(domain1, domain2) {
    try {
      const response = await axios.post('/api/analysis/compare', {
        domain1,
        domain2
      });
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // Get dashboard statistics
  async getDashboardStats() {
    try {
      const response = await axios.get('/api/user/dashboard-stats');
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // Schedule a scan (Pro/Plus tier only)
  async scheduleScan(scanData) {
    try {
      const response = await axios.post('/api/analysis/schedule', scanData);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // Get scheduled scans
  async getScheduledScans() {
    try {
      const response = await axios.get('/api/analysis/scheduled');
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // Cancel a scheduled scan
  async cancelScheduledScan(id) {
    try {
      const response = await axios.delete(`/api/analysis/scheduled/${id}`);
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // Bulk scan multiple URLs
  async bulkScan(urls) {
    try {
      const response = await axios.post('/api/analysis/bulk-scan', { urls });
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // Export scan result as PDF
  async exportScanResult(id, format = 'pdf') {
    try {
      const response = await axios.get(`/api/analysis/${id}/export`, {
        params: { format },
        responseType: 'blob'
      });
      
      // Create download link
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `scan-report-${id}.${format}`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      
      return true;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // Get competitor insights
  async getCompetitorInsights(domain) {
    try {
      const response = await axios.get('/api/competitor/insights', {
        params: { domain }
      });
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  // Track competitor changes
  async trackCompetitor(domain) {
    try {
      const response = await axios.post('/api/competitor/track', { domain });
      return response.data;
    } catch (error) {
      throw this.handleError(error);
    }
  }

  handleError(error) {
    const message = error.response?.data?.message || 
                   error.response?.data?.error || 
                   error.message || 
                   'An unexpected error occurred';
    return new Error(message);
  }
}

export default new ScanService();